module.exports = __webpack_public_path__ + "static/img/pic7.3a81b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic7.png
// module id = 8qAo
// module chunks = 1